import type { ReactNode } from 'react';

import type { FormSection as FormSectionType } from '../schemas.js';

export interface FormSectionProps {
  section: FormSectionType;
  /** Conteúdo renderizado das perguntas (já filtradas por visible_if). */
  children: ReactNode;
}

/**
 * Container visual de uma seção do formulário. Consome os tokens do
 * DS (`bg-card`, `border-border`, `text-muted-foreground`) — trocar
 * paleta global reflete aqui.
 *
 * Mobile-first: padding reduzido em mobile, cresce em `sm+`. Títulos
 * ficam em `text-lg` para leitura confortável e hierarquia clara
 * contra o `text-xl` da página (título do form).
 */
export function FormSection({ section, children }: FormSectionProps) {
  return (
    <section className="rounded-lg border border-border bg-card p-4 shadow-sm sm:p-6">
      <header className="mb-4 space-y-1 sm:mb-6">
        <h2 className="text-lg font-semibold text-foreground sm:text-xl">{section.title}</h2>
        {section.description ? (
          <p className="text-sm text-muted-foreground">{section.description}</p>
        ) : null}
      </header>
      <div className="space-y-5">{children}</div>
    </section>
  );
}
